<template>
    <div class="orders-history">
        <v-card class="section-card" elevation="0">
            <div class="card-head">
                <div class="head-gradient head-gradient--green" />
                <div class="head-inner d-flex align-center justify-space-between">
                    <div>
                        <h2 class="form-title">ประวัติการซื้อ</h2>
                    </div>
                </div>
            </div>

            <v-divider class="mb-4" />

            <div class="section-form pt-0">
                <div v-if="loading" class="py-8 d-flex justify-center">
                    <v-progress-circular indeterminate size="32" width="3" color="#16a34a" />
                </div>

                <div v-else-if="items.length === 0" class="empty-wrap">
                    <div class="empty-card">
                        <v-icon size="40" color="#9ca3af" class="mb-2">mdi-cart-off</v-icon>
                        <div class="empty-title">ยังไม่มีประวัติการซื้อ</div>
                        <div class="empty-sub">สั่งซื้อสินค้าที่น่าสนใจได้ใน Marketplace</div>
                    </div>
                </div>

                <div v-else class="orders-list">
                    <div v-for="(order, index) in pagedItems" :key="order.id" class="order-block">
                        <OrderCard :order="order" :is-tracking="false" @refresh="fetchData" />
                        <v-divider v-if="index < pagedItems.length - 1" class="my-6" />
                    </div>

                    <div class="pagination-row mt-6" v-if="items.length > itemsPerPage">
                        <v-pagination v-model="page" :length="pageCount" :total-visible="7" prev-icon="<" next-icon=">"
                            class="mx-2" color="#5C96F8" />
                    </div>
                </div>
            </div>
        </v-card>
    </div>
</template>

<script>
import swalAlert from "@/services/alert/swalServices";
import { getOrderHistoryApi } from "@/services/api/userServices";
import OrderCard from "./OrderCard.vue";

export default {
    name: "OrderHistory",
    components: {
        OrderCard
    },
    data() {
        return {
            loading: false,
            items: [],
            page: 1,
            itemsPerPage: 5,
        };
    },

    computed: {
        pageCount() {
            if (this.items.length === 0) return 1;
            return Math.ceil(this.items.length / this.itemsPerPage);
        },
        pagedItems() {
            const start = (this.page - 1) * this.itemsPerPage;
            return this.items.slice(start, start + this.itemsPerPage);
        },
    },

    methods: {
        async fetchData() {
            this.loading = true;
            try {
                const res = await getOrderHistoryApi();
                this.items = Array.isArray(res?.data) ? res.data : [];
            } catch (e) {
                console.error(e);
                swalAlert.Error("โหลดข้อมูลประวัติการซื้อไม่สำเร็จ");
            } finally {
                this.loading = false;
            }
        },
    },

    mounted() {
        this.fetchData();
    },
};
</script>

<style scoped>
.section-card {
    background: #fff;
    border: 1px solid #f1f5f9;
    border-radius: 16px;
    box-shadow: 0 12px 28px rgba(2, 6, 23, 0.06);
}

.card-head {
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    overflow: hidden;
}

.head-gradient {
    height: 76px;
    opacity: 0.18;
}

.head-gradient--green {
    background: linear-gradient(100deg, #d6230b 0%, #eed7d5 100%);
}

.head-inner {
    padding: 22px 24px 16px;
}

.form-title {
    font-size: 22px;
    font-weight: 800;
    color: #0f172a;
    margin-bottom: 6px;
    font-family: "Noto Sans Thai", system-ui, Arial, sans-serif;
}

.subtitle {
    color: #6b7280;
    margin-bottom: 8px;
}

.section-form {
    padding: 22px 24px 28px;
}

.empty-wrap {
    text-align: center;
    padding: 60px 0;
}

.empty-title {
    font-size: 18px;
    font-weight: 700;
    color: #212121;
}

.empty-sub {
    color: #757575;
}

.pagination-row {
    display: flex;
    justify-content: center;
}

::v-deep .v-pagination__item {
    box-shadow: none !important;
    border: 1px solid #e0e0e0;
}

::v-deep .v-pagination__navigation {
    box-shadow: none !important;
    border: 1px solid #e0e0e0;
}

@media (max-width: 600px) {
    .head-inner {
        padding: 12px 14px 12px;
    }

    .section-form {
        padding: 12px 14px 20px;
    }
}
</style>
